"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTradeskillLevelFromXP = calculateTradeskillLevelFromXP;
exports.calculateTradeskillXPRequiredForLevel = calculateTradeskillXPRequiredForLevel;
exports.calcTradeskillLevelForCharacter = calcTradeskillLevelForCharacter;
const TRADESKILL_COEFFICIENT = 1.35;
// tradeskill functions
function calculateTradeskillLevelFromXP(skillXP) {
    const skillValue = skillXP ?? 0;
    if (skillValue < 5)
        return 0;
    const value = Math.log(skillValue / 5) / Math.log(TRADESKILL_COEFFICIENT);
    return Math.floor(value);
}
function calculateTradeskillXPRequiredForLevel(level) {
    if (level === 0)
        return 5;
    return Math.floor(Math.pow(TRADESKILL_COEFFICIENT, level) * 5);
}
function calcTradeskillLevelForCharacter(character, skill) {
    if (!skill) {
        throw new Error('Trying to calculate skill of undefined');
    }
    const skillValue = character.tradeskills[skill.toLowerCase()] ?? 0;
    return calculateTradeskillLevelFromXP(skillValue);
}
